/* unplugin-vue-components disabled */import script from "./PersonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonView.vue?vue&type=script&setup=true&lang=ts"

import "./PersonView.vue?vue&type=style&index=0&id=1de80324&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de80324"]])

export default __exports__